export enum PaymentMethodStatus {
    Pending = 'pending',
    PendingMandate = 'pending-mandate',
    Active = 'active',
    Inactive = 'inactive',
    Disconnected = 'disconnected',
}
